import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'campaignAddEmail'

export default (id, alternativeCampaignId) => {
  const data = { id }
  if (alternativeCampaignId) {
    data.alternativeCampaignId = alternativeCampaignId
  }
  return asyncAction(
    name,
    CampaignsService.campaignAddEmail,
    data
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/campaignAddEmail.js